import React, { useState, useContext, useEffect } from "react";
import { Input } from "design-react-kit";
import { useLocation } from "react-router-dom";
import Repo from "../../Utility/Repo";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import ModalComponent from "../../Components/ModalComponent";
import Select from "../../Components/Select";
import { TokenContext } from "../../Components/TokenContext";
import jwt_decode from "jwt-decode";
import AllegatiComponent from "../../Components/AllegatiComponent";
import { format, parseISO } from "date-fns";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ViewExecutive() {
  const apiToken = useContext(TokenContext);
  let query = useQuery();
  const idExecutive = query.get("id");

  // Dati che verranno presi con API
  const [executive, setExecutive] = useState({
    name: "",
    pIva: "",
    address: "",
    announcementId: "",
    announcementName: "",
    executiveId: "",
    note: "",
    storageFiles: [],
    isEnabled: true,
    id: "",
    dataInsert: "",
    dataUpdate: "",
    isVisible: true,
  });

  // Stato iniziale della modifica e per il reset;  che non dovrà cambiare
  const executiveInitialState = {
    id: "",
    name: "",
    pIva: "",
    address: "",
    announcementId: "",
    announcementName: "",
    note: "",
  };

  const [formData, setFormData] = useState(executiveInitialState);
  const [showModalModify, setshowModalModify] = useState(false);
  const [servizi, setServizi] = useState([]);
  const [infoCoupon, setInfoCoupon] = useState();
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [isOpenState, toggleModalState] = useState(false);
  const [listCoupon, setListCoupon] = useState(false);

  useEffect(() => {
    Repo.getExecutiveIdByOperator(apiToken, idExecutive)
      .then((response) => {
        setExecutive(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    Repo.getListaInterventi(apiToken)
      .then((response) => {
        setServizi(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    Repo.getExecutiveStatisticsByOperator(
      apiToken,
      idExecutive,
      dateStart,
      dateEnd
    )
      .then((response) => {
        setInfoCoupon(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    Repo.ListCouponsUsed(apiToken, idExecutive)
      .then((response) => {
        setListCoupon(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [dateEnd, dateStart]);

  const handleChangeStart = (e) => {
    const date = parseISO(e.target.value);
    const formattedDate = format(date, "yyyy-MM-dd");
    setDateStart(formattedDate);
  };

  const handleChangeEnd = (e) => {
    const date = parseISO(e.target.value);
    const formattedDate = format(date, "yyyy-MM-dd");
    setDateEnd(formattedDate);
  };

  const handleUpdate = () => {
    Repo.postExecutiveInfoByOperator(
      apiToken,
      idExecutive,
      JSON.stringify(formData)
    )
      .then((response) => {
        if (response.status === 204) {
          setshowModalModify(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    window.location.reload();
  };

  const toggleModalModify = () => {
    setshowModalModify(!showModalModify);
  };

  const handleCloseModalModify = () => {
    setshowModalModify(false);
    resetFormFields();
  };

  const cambiaStatoEsercente = () => {
    let enable = executive.isEnabled === false ? true : false;
    Repo.postExecutiveEnableByOperator(apiToken, idExecutive, enable)
      .then((response) => {
        if (response.status === 204) {
          toggleModalState(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    window.location.reload();
  };
  const resetFormFields = () => {
    setFormData(executiveInitialState);
  };

  const selectNewSeviceModify = (e) => {
    setFormData({
      ...formData,
      announcementId: e.value,
      announcementName: e.label,
    });
  };

  const showModify = (ogg) => {
    formData.id = idExecutive;
    formData.name = ogg.name;
    formData.pIva = ogg.pIva;
    formData.address = ogg.address;
    formData.note = ogg.note;
    formData.announcementId = ogg.announcementId;
    formData.announcementName = "pippo";
    setshowModalModify(true);
  };

  const bodyModify = () => {
    return (
      <>
        <div className="row">
          <div className="col-lg-12 mt-3">
            <label htmlFor="name">Name</label>
            <div className="form-group">
              <input
                type="text"
                id="name"
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                value={formData.name}
              />
            </div>

            <label htmlFor="pIVA">Partita IVA</label>
            <div className="form-group">
              <input
                type="text"
                id="pIVA"
                onChange={(e) =>
                  setFormData({ ...formData, pIva: e.target.value })
                }
                value={formData.pIva}
              />
            </div>

            <label htmlFor="address">Indirizzo</label>
            <div className="form-group">
              <input
                type="text"
                id="address"
                onChange={(e) =>
                  setFormData({ ...formData, address: e.target.value })
                }
                value={formData.address}
              />
            </div>

            <label htmlFor="note">Note</label>
            <div className="form-group">
              <input
                type="text"
                id="note"
                onChange={(e) =>
                  setFormData({ ...formData, note: e.target.value })
                }
                value={formData.note}
              />
            </div>

            <label htmlFor="intervento">Intervento:</label>
            <div className="select-wrapper">
              <Select
                aria-label="Intervento"
                clearText="Annulla"
                defaultMenuIsOpen={false}
                required
                icon={false}
                name="intervento"
                id="intervento"
                options={servizi}
                onChange={(e) => selectNewSeviceModify(e)}
                isClearable
                isSearchable
                placeholder={
                  executive
                    ? executive.announcementName
                    : "Seleziona intervento"
                }
              />
            </div>

            <div className="d-flex justify-content-end">
              <button
                className="btn btn-primary btn-salva"
                type="button"
                onClick={handleUpdate}
              >
                Modifica
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="col-lg-12 mt-3">
        <h1>Profilo esercente</h1>
        <div className="row">
          <div className="clearfix col-lg-8 py-lg-2">
            <p>
              {executive && executive.isEnabled === true
                ? "ABILITATO"
                : "SOSPESO"}
            </p>
            <p>
              Di seguito potrai visualizzare e modificare i dati relativi
              all'esercente
            </p>
          </div>
          <div className="col-lg-4 d-flex justify-content-end">
            <div>
              <button
                className="btn btn-success mr-2 "
                type="button"
                onClick={() => toggleModalState(true)}
              >
                {executive && executive.isEnabled === false
                  ? "ABILITA"
                  : "SOSPENDI"}
              </button>
            </div>
          </div>
        </div>

        <div className="card-wrapper card-space">
          <div className="card card-bg no-after card-big roundedCustom">
            <br />
            {executive && (
              <div className="card-body">
                <div
                  className="row"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h4>Dati esercente </h4>
                  <div className="etichetta ">
                    <svg className="icon icon-primary">
                      <use href={`${iconSprite}#it-pencil`}></use>
                    </svg>
                    <span>
                      <a
                        className="text-decoration-none"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          showModify(executive);
                        }}
                      >
                        Modifica
                      </a>
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4 p-3">
                    Nome:{" "}
                    <strong>
                      {executive && executive.name ? executive.name : " "}
                    </strong>
                  </div>

                  <div className="col-lg-4 p-3">
                    Partita IVA:{" "}
                    <strong>
                      {executive && executive.pIva ? executive.pIva : " "}
                    </strong>
                  </div>

                  <div className="col-lg-4 p-3">
                    Indirizzo:{" "}
                    <strong>
                      {executive && executive.address ? executive.address : " "}{" "}
                    </strong>
                  </div>

                  <div className="col-lg-4 p-3">
                    Note:{" "}
                    <strong>
                      {executive && executive.note ? executive.note : " "}
                    </strong>
                  </div>

                  <div className="col-lg-8 p-3">
                    Intervento:{" "}
                    <strong>
                      {executive && executive.announcementName
                        ? executive.announcementName
                        : " "}
                    </strong>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <AllegatiComponent entityId={idExecutive} tipoEntity="Executive" />

        <div className="card-wrapper card-space">
          <div className="card card-bg no-after card-big roundedCustom">
            <div className="card-body">
              <h4>Dati dei buoni servizio dell'esercente </h4>
              <br />
              <p>
                Hai la possibilità di visualizzare i dati relativi ai buoni
                servizio in un range temporale
              </p>
              <br />
              <div className="row mt-2">
                <div className="form-group col-md-6">
                  <div className="form-group">
                    <label
                      className="active"
                      handleChangeEndtmlFor="dateStandard"
                    >
                      Data inizio periodo
                    </label>
                    <input
                      type="date"
                      id="dateStandard"
                      name="dateStandard"
                      onChange={handleChangeStart}
                    />
                  </div>
                </div>
                <div className="form-group col-md-6">
                  <div className="form-group">
                    <label className="active" htmlFor="dateStandard">
                      Data fine periodo
                    </label>
                    <input
                      type="date"
                      id="dateStandard"
                      name="dateStandard"
                      onChange={handleChangeEnd}
                      min={dateStart}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                {infoCoupon ? (
                  Object.entries(infoCoupon).map(([key, dizionario]) =>
                    Object.entries(dizionario).map((valoreElemento) => (
                      <div className="col-lg-4 p-3">
                        {valoreElemento[0]} :
                        <strong>{valoreElemento[1]}</strong>
                      </div>
                    ))
                  )
                ) : (
                  <p>Non sono presenti buoni relativi a questa attività</p>
                )}
              </div>

              <hr />
              <h4>Lista buoni scansionati</h4>
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th style={{ textAlign: "left" }}>ID buono</th>
                    <th style={{ textAlign: "center" }}>CF</th>
                    <th style={{ textAlign: "center" }}>Titolo</th>
                    <th style={{ textAlign: "center" }}>Valore</th>
                    <th style={{ textAlign: "center" }}>Data utilizzo</th>
                  </tr>
                </thead>
                <tbody>
                  {listCoupon &&
                    listCoupon.map((elemento, index) => (
                      <tr key={index}>
                        <td style={{ textAlign: "left" }}>
                          {elemento.coupon.id}
                        </td>
                        <td style={{ textAlign: "left" }}>
                          {elemento.coupon.user.fiscalCode}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {elemento.coupon.title}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {elemento.coupon.valore} €
                        </td>
                        <td style={{ textAlign: "center" }}>
                          ({elemento.usageDate}-{elemento.usageDateTime})
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <ModalComponent
        toggleModal={toggleModalModify}
        isOpen={showModalModify}
        header="Modifica valori attività"
        body={bodyModify()}
        buttonDeny="Chiudi"
        onClose={handleCloseModalModify}
      />
      <ModalComponent
        toggleModal={toggleModalState}
        isOpen={isOpenState}
        header="Cambia Stato"
        body={
          executive &&
          `Confermi di voler modificare lo stato in ${
            executive.isEnabled === false ? "ABILITA" : "SOSPESO"
          } di ${executive.name}?`
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => cambiaStatoEsercente()}
      ></ModalComponent>
    </>
  );
}

export default ViewExecutive;
